import ImprivataDefaultLogo from '@assets/default_logo.svg';
import { useSession } from '@common/authorization/context/Session';
import { useSelfServiceData } from '@selfservice/utils/useSelfServiceData';
import { Outlet } from 'react-router-dom';
import SelfServiceLayout from './SelfServiceLayout';

// Shown while org branding is still loading: a blank SVG that holds the footer
// logo's space without flashing the default logo before the custom one resolves
// (PORT-390). Once loaded, the org's custom logo is used, falling back to the
// default logo when none is configured.
const BLANK_LOGO = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>';

export const SelfServiceContainer = () => {
  const { userInfo } = useSession();

  const { data, isLoading } = useSelfServiceData();

  const logoUrl = isLoading ? BLANK_LOGO : data?.orgInfo?.logoUrl || ImprivataDefaultLogo;
  const username = userInfo?.userDisplayName || userInfo?.userUpn || userInfo?.email || '';

  return (
    <SelfServiceLayout logoUrl={logoUrl} username={username} email={username}>
      <Outlet />
    </SelfServiceLayout>
  );
};
